import React from "react";
import SloughToHeathrowGroupRoute from "./SloughToHeathrowGroupRoute";

const SloughToHeathrowCoachRoute = () => <SloughToHeathrowGroupRoute variant="coach" />;

export default SloughToHeathrowCoachRoute;
